import authService from './authService';

const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://uni-func-pd-thrive360.azurewebsites.net/api';

const getPowerBIErrorMessage = (err, fallback) => {
  const rawError = err?.error || err?.message || err;
  if (typeof rawError === 'string') return rawError;
  if (rawError?.code) return rawError.code;
  try {
    return JSON.stringify(rawError);
  } catch (e) {
    return fallback;
  }
};

export async function fetchPowerBIEmbedToken(reportId, workspaceId = '7d441575-4aa9-4260-99dd-543f002c0340', username, countries, applyRLS = true, roleName, datasetId, pageName) {
  const idToken = await authService.getIdToken();
  const res = await fetch(`${API_BASE}/powerbi/getEmbedToken`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ reportId, datasetId, workspaceId, username, countries, applyRLS, roleName, pageName }),
    mode: 'cors'
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(getPowerBIErrorMessage(err, `Failed to get embed token (${res.status})`));
  }
  return res.json();
}

export async function fetchPowerBISemanticData(datasetId, workspaceId, query, maxRows = 200, tableName) {
  const idToken = await authService.getIdToken();
  const res = await fetch(`${API_BASE}/powerbi/getSemanticData`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ datasetId, workspaceId, query, tableName, maxRows }),
    mode: 'cors'
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(getPowerBIErrorMessage(err, `Failed to query semantic model (${res.status})`));
  }
  return res.json();
}

export async function fetchPowerBIFabricSqlData({ query, tableName, maxRows = 200, params, server, database } = {}) {
  const idToken = await authService.getIdToken();
  const res = await fetch(`${API_BASE}/powerbi/getSemanticData`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
    body: JSON.stringify({ source: 'fabricSql', query, tableName, maxRows, params, server, database }),
    mode: 'cors'
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(getPowerBIErrorMessage(err, `Failed to query Fabric SQL data (${res.status})`));
  }
  return res.json();
}


